import React from 'react';
import './About.css'
import img from './../assets/sec2-image.png';
import Subtitle from '../components/Subtitle';
import Title from '../components/Title';
import Paragraph from '../components/Paragraph';

const About = () => {
    return ( <>
        <section className='section2'>
        <img src={img} alt=''/>
        <div className='sec2-container'>
        <Subtitle text="About the Firm" css3="subtitle" />
        <Title text2="Building Trust Through Legal Excellence" css6="text6"/>
        <div className='line1'></div>
        <Paragraph text2='Since our founding in 1995, Sterling & Associates has established itself as a premier legal firm dedicated to providing sophisticated, strategic counsel across a comprehensive range of practice areas.' css7='paragraph6'/>
        </div>
        
        </section>
    </>);
}
 
export default About;